import mountVueOnPage from '../mount_vue'
import RecipientPicker from '../recipient_picker.vue'

mountVueOnPage('messages', 'new', {
    components: {
        'recipient-picker': RecipientPicker,
    },
})
